export class DomainRecordFilter {
    
    public TableName?: string;
}

export default DomainRecordFilter;